// extracted by mini-css-extract-plugin
module.exports = {"arc-group-button":"groupButton_arc-group-button__2oIcc"};